"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function NextDelayTimeMsFromExponentialBackoff(localTryCount) {
    return Math.pow(2, localTryCount) * 1000 + getRandomFrom0To1000();
}
exports.NextDelayTimeMsFromExponentialBackoff = NextDelayTimeMsFromExponentialBackoff;
function getRandomFrom0To1000() {
    return Math.random() * 1000;
}
//# sourceMappingURL=ExponentialBackoffHelper.js.map